<template>
  <div class="mCheckout__successPage mCheckout">
    <div class="mCheckout__successPage-header" v-if="mCheckout.siteLogo">
      <a class="mCheckout-header-logo" href="/">
        <img :src="mCheckout.siteLogo" alt="logo">
      </a>
    </div>
    <div class="mCheckout__successPage-title">
      {{ translate('success_title') }}
    </div>
    <div class="mCheckout__successPage-subtitle">
      {{ translate('success_description') }}
    </div>
    <div class="mCheckout__successPage-content">
      <div class="row">
        <div class="col-md-12">
          <div class="mCheckout__item mCheckout-miniCart">
            <div class="mCheckout__item-title">
              {{ translate('success_order_number') }}{{ data.order.id }}<span>{{ translate('order_date_from') }} {{ data.order.order_date }}</span>
            </div>
            <div class="mCheckout__item-info">
              <div class="mCheckout__info-products">
                <div class="mCheckout__itemProduct" v-for="item in data.order.products">
                  <a :href="item.link">
                       <span class="mCheckout__itemProduct-img">
                       <img class="mCheckout__img" :src="item.image" alt="">
                       </span>
                  </a>
                  <div class="mCheckout__itemProduct-detail">
                    <div>
                      <span class="name">
                         <a :href="item.link">{{ item.title }}</a>
                      </span>
                      <div v-if="item?.attributes && item.attributes.length" class="parameters">
                        <span
                            v-for="(attr, index) in item.attributes"
                            :key="index"
                        >
                          {{ attr.name }} {{ attr.value }}
                        </span>
                      </div>
                    </div>
                    <div class="productTotal">
                      <div class="total">
                        <span v-if="item.old_price" class="price">
                          <span class="old-price">{{ formatPrice(item.regular_price) }}
                            {{ data.currency }}
                          </span>
                          <span>{{ formatPrice(item.price) }} {{ data.currency }} </span>
                        </span>
                        <span v-else class="price">
                           <span>{{ formatPrice(item.price) }} {{ data.currency }} </span>
                        </span>
                        <span class="quantity"> x {{ item.quantity }}
                          {{ translate('count_title') }}
                        </span>
                      </div>
                      <div class="sum">
                        <span v-if="item.old_price" class="old-price">
                          {{ formatPrice(parseFloat(item.regular_price) * item.quantity) }} {{ data.currency }}
                        </span>
                        <span>{{ formatPrice(parseFloat(item.price) * item.quantity) }} {{ data.currency }} </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mCheckout__info-detail">
                <div class="wrap">
                  <div class="mCheckout__info-detail-item delivery">
                    <div class="title">
                      {{ translate('delivery_title') }} <span> ({{ data.order.delivery }})</span>
                    </div>
                    <div v-if="data.order.user_info.city" class="subtitle">
                      {{ data.order.user_info.city }}
                    </div>
                    <div v-if="data.order.user_info.address" class="subtitle">
                      {{ data.order.user_info.address }}
                    </div>
                  </div>
                  <div class="mCheckout__info-detail-item delivery">
                    <div class="title">{{ translate('payment_title') }}</div>
                    <div class="subtitle">
                      {{ data.order.payment }}
                    </div>
                  </div>
                </div>
                <div class="mCheckout__info-detailPrice">
                  {{ formatPrice(data.order.delivery_cost) }} {{ data.currency }}
                </div>
              </div>
              <div class="mCheckout__info-total">
                <div class="wrap">
                  <div class="title">{{ translate('success_total_title') }}:</div>
                  <div class="subtitle" v-if="data.isDeposit">{{ translate('pre_sale_title') }}
                  </div>
                </div>
                <div class="info__total-price">
                  {{ formatPrice(data.order.total) }} {{ data.currency }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {translate} from "@/composable/useTranslates";
import {ref} from "vue";
import {formatPrice} from "@/composable/useWooCommerce";

const mCheckout = ref(window.mCheckout);

const data = ref({
  order: mCheckout.value.order,
  currency: mCheckout.value.currency,
  isDeposit: mCheckout.value.order.isDeposit
});
</script>

<style lang="scss">
@import "@/assets/styles/plugins/checkout";
@import "@/assets/styles/plugins/successPage";
@import "@/assets/styles/plugins/miniCart";
</style>
